import {
  GET_DMX_UNIVERSES_BY_CONTROLLER,
  GET_DMX_UNIVERSES_BY_CONTROLLER_SUCCESS,
  GET_DMX_UNIVERSES_BY_CONTROLLER_ERROR,
} from './actionTypes';

const initialState = {
  errorGetDmxUniverses: '',
  loadingGetDmxUniverses: false,
  universes: null,
};

const getUniversesByController = (state = initialState, action) => {
  switch (action.type) {
    case GET_DMX_UNIVERSES_BY_CONTROLLER:
      state = { ...state, loadingGetDmxUniverses: true };
      break;
    case GET_DMX_UNIVERSES_BY_CONTROLLER_SUCCESS:
      state = { ...state, loadingGetDmxUniverses: false, universes: action.payload.universes };
      break;
    case GET_DMX_UNIVERSES_BY_CONTROLLER_ERROR:
      state = { ...state, errorGetDmxUniverses: action.payload, loadingGetDmxUniverses: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getUniversesByController;
